import { Box, BoxProps, useTheme } from "@mui/material";
import React from "react";
import Tab, { TabVariant } from "./tab/tab";

export interface NavbarTab {
  id: string;
  label?: string;
  icon?: React.ReactNode;
  /** short pill rendered after the label (e.g. "New") */
  badgeLabel?: string;
}

export interface NavbarProps extends Omit<BoxProps, "variant"> {
  tabs: NavbarTab[];
  activeTab?: string;
  variant?: TabVariant;
  onTabChange?: (tabId: string) => void;
}

export const Navbar: React.FC<NavbarProps> = ({
  tabs,
  activeTab,
  variant = "primary",
  onTabChange,
  ...props
}) => {
  const theme = useTheme();
  const handleTabClick = (tabId: string) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderBottom: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
      }}
      {...props}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          label={tab.label}
          badgeLabel={tab.badgeLabel}
          icon={tab.icon}
          variant={variant}
          selected={activeTab === tab.id}
          onClick={() => handleTabClick(tab.id)}
          data-testid={`tab-${tab.id}`}
        />
      ))}
    </Box>
  );
};

export default Navbar;
